// TODO:import store from '@/store'
import Cookies from 'js-cookie'

function getNavJson() {
  let data = [{
    id: '1',
    name: '知涯',
    depth: 3,
    subNav: [
      {
        id: '1-1',
        name: '专题管理',
        subNav: [{
          //   id: '1-1-1',
          //   name: '大学',
          //   url: 'zhiyuan/special-list',
          //   type: 'college',
          //   auth: 'zhiyuan-special-college'
          // }, {
          //   id: '1-1-2',
          //   name: '专业',
          //   url: 'zhiyuan/special-list',
          //   type: 'major',
          //   auth: 'zhiyuan-special-major'
          // }, {
          //   id: '1-1-3',
          //   name: '职业',
          //   url: 'zhiyuan/special-list',
          //   type: 'profession',
          //   auth: 'zhiyuan-special-profession'
          // }, {
          id: '1-1-4',
          name: '首页',
          url: 'zhiyuan/special-list',
          type: 'index',
          auth: 'zhiyuan-special-index'
        }, {
          id: '1-1-5',
          name: '生涯课堂',
          url: 'zhiyuan/special-list',
          type: 'career-plan',
          auth: 'zhiyuan-special-career-plan'
        }, {
          //   id: '1-1-6',
          //   name: '志愿锦囊',
          //   url: 'zhiyuan/special-list',
          //   type: 'volunteer-questions',
          //   auth: 'zhiyuan-special-volunteer-questions'
          // }, {
          id: '1-1-7',
          name: '升学课堂',
          url: 'zhiyuan/special-list',
          type: 'entrance-class',
          auth: 'zhiyuan-special-entrance-class'
        }, {
          id: '1-1-8',
          name: 'Web资讯',
          url: 'zhiyuan/special-list',
          type: 'news',
          auth: 'zhiyuan-special-news'
        }, {
          id: '1-1-9',
          name: '志愿指南',
          url: 'zhiyuan/special-list',
          type: 'good-volunteer',
          auth: 'zhiya-special-zhiyuan-enroll'
        }, {
          id: '1-1-10',
          name: '选科指导',
          url: 'zhiyuan/special-list',
          type: 'guidance',
          auth: 'zhiya-special-xuanke-guide'
        }, {
          id: '1-1-11',
          name: '1对1官网专题',
          url: 'zhiyuan/special-list',
          type: 'news11',
          auth: 'zhiyuan-special-news'
        }, {
          id: '1-1-12',
          name: '小程序',
          url: 'zhiyuan/special-list',
          type: 'applet',
          auth: 'zhiyuan-special-news'
        }, {
          id: '1-1-15',
          name: '父母城邦',
          url: 'zhiyuan/special-list',
          type: 'SaaS',
          auth: 'platform-parents-city-state'
        }],
        auth: function () {
          return secondAuth(this.subNav)
        }
      }, {
        id: '1-2',
        name: '文章管理',
        subNav: [{
          //   id: '1-2-1',
          //   name: '大学',
          //   url: 'zhiyuan/article-list',
          //   type: 'college',
          //   auth: 'zhiyuan-article-college'
          // }, {
          //   id: '1-2-2',
          //   name: '专业',
          //   url: 'zhiyuan/article-list',
          //   type: 'major',
          //   auth: 'zhiyuan-article-major'
          // }, {
          //   id: '1-2-3',
          //   name: '职业',
          //   url: 'zhiyuan/article-list',
          //   type: 'profession',
          //   auth: 'zhiyuan-article-profession'
          // }, {
          id: '1-2-4',
          name: '首页',
          url: 'zhiyuan/article-list',
          type: 'index',
          auth: 'zhiyuan-article-index'
        }, {
          id: '1-2-5',
          name: '生涯课堂',
          url: 'zhiyuan/article-list',
          type: 'career-plan',
          auth: 'zhiyuan-article-career-plan'
        }, {
          //   id: '1-2-6',
          //   name: '志愿锦囊',
          //   url: 'zhiyuan/article-list',
          //   type: 'volunteer-questions',
          //   auth: 'zhiyuan-article-volunteer-questions'
          // }, {
          id: '1-2-7',
          name: '升学课堂',
          url: 'zhiyuan/article-list2',
          type: 'entrance-class',
          auth: 'zhiyuan-article-entrance-class'
        }, {
          id: '1-2-8',
          name: 'Web资讯',
          url: 'zhiyuan/article-list',
          type: 'news',
          auth: 'zhiyuan-article-news'
        }, {
          id: '1-2-9',
          name: '志愿指南',
          url: 'zhiyuan/article-list',
          type: 'good-volunteer',
          auth: 'zhiya-article-zhiyuan-enroll'
        }, {
          id: '1-2-10',
          name: '选科指导',
          url: 'zhiyuan/article-list',
          type: 'guidance',
          auth: 'zhiya-article-xuanke-guide'
        },
        //  {
        //   id: '1-2-11',
        //   name: '1对1官网资讯',
        //   url: 'zhiyuan/article-list',
        //   type: 'news11',
        //   auth: 'zhiyuan-article-news'
        // },
        // {
        //   id: '1-1-12',
        //   name: '小程序',
        //   url: 'zhiyuan/article-list',
        //   type: 'applet',
        //   auth: 'zhiyuan-special-news'
        // },
        // {
        //   id: '1-2-15',
        //   name: '父母城邦',
        //   url: 'zhiyuan/article-list',
        //   type: 'SaaS',
        //   auth: 'platform-parents-city-state'
        // }, 
        {
          id: '1-2-15',
          name: '父母城邦',
          url: 'zhiyuan/article-list4',
          type: 'SaaS',
          auth: 'platform-parents-city-state'
        }, 
        {
          id: '1-2-16',
          name: '知涯小程序',
          url: 'zhiyuan/article-list3',
          type: 'yanxue',
          auth: 'zhiyuan-article-news'
        }],
        auth: function () {
          return secondAuth(this.subNav)
        }
      }, {
        id: '1-3',
        name: 'banner管理',
        subNav: [{
          id: '1-3-1',
          name: '首页',
          url: 'shengxue/banner-list',
          type: 'index',
          auth: 'shengxue-banner-index'
        },
        {
          id: '1-3-2',
          name: '小程序首页',
          url: 'shengxue/banner-list',
          type: 'applet',
          auth: 'banner-one-to-one'
        },
        {
          id: '1-3-3',
          name: '小程序升学规划',
          url: 'shengxue/banner-list',
          type: 'yanxue',
          auth: 'banner-applet'
        },
        {
          id: '1-3-5',
          name: '生涯师训',
          url: 'shengxue/banner-list',
          type: 'shixun',
          auth: 'banner-applet'
        },
        {
          id: '1-3-4',
          name: '父母城邦',
          url: 'shengxue/banner-list',
          type: 'SaaS',
          auth: 'banner-applet'
        }
       
          // {
          //   id: '1-3-2',
          //   name: '1对1',
          //   url: 'shengxue/banner-list',
          //   type: 'news11',
          //   auth: 'banner-one-to-one'
          // }, 
          // {
          //   id: '1-3-3',
          //   name: '小程序',
          //   url: 'shengxue/banner-list',
          //   type: 'applet',
          //   auth: 'banner-applet'
          // }
        ],
        // subNav: [{
        //   id: '1-3-1',
        //   name: '首页',
        //   url: 'zhiyuan/banner-list',
        //   type: 'index',
        //   auth: 'zhiyuan-banner-index'
        // }, {
        //   id: '1-3-2',
        //   name: '生涯规划',
        //   url: 'zhiyuan/banner-list',
        //   type: 'career-plan',
        //   auth: 'zhiyuan-banner-career-plan'
        // }],
        auth: function () {
          return secondAuth(this.subNav)
        }
      }, {
        id: '1-4',
        name: '咨询',
        depth: 3,
        url: 'zixun/index',
        auth: function () {
          return "h5-activity-manager"
        }
      }],
    auth: function () {
      return firstAuth(this.subNav)
    }
  },
  // {
  //   id: '2',
  //   name: '知涯选科',
  //   depth: 3,
  //   subNav: [{
  //     id: '2-1',
  //     name: '内容管理',
  //     subNav: [{
  //       id: '2-1-1',
  //       name: '专题',
  //       url: 'xuanke/special-list',
  //       auth: 'xuanke-special-list'
  //     }, {
  //       id: '2-1-2',
  //       name: '文章',
  //       url: 'xuanke/article-list',
  //       auth: 'xuanke-article-list'
  //     }, {
  //       id: '2-1-3',
  //       name: '话题',
  //       url: 'xuanke/topic-list',
  //       auth: 'xuanke-topic-list'
  //     }],
  //     auth: function () {
  //       return secondAuth(this.subNav)
  //     }
  //   }],
  //   auth: function () {
  //     return firstAuth(this.subNav)
  //   }
  // }, 
  // {
  //   id: '9',
  //   name: '知涯',
  //   depth: 3,
  //   subNav: [
  //     {
  //       id: '9-1',
  //       name: '专题管理',
  //       subNav: [{
  //         id: '9-1-1',
  //         name: '首页',
  //         url: 'zhiyuan/special-list',
  //         type: 'zhiyaIndex',
  //         auth: 'zhiya-special-index'
  //       }],
  //       auth: function () {
  //         return secondAuth(this.subNav)
  //       }
  //     }, {
  //       id: '9-2',
  //       name: '文章管理',
  //       subNav: [{
  //         id: '9-2-1',
  //         name: '首页',
  //         url: 'zhiyuan/article-list',
  //         type: 'zhiyaIndex',
  //         auth: 'zhiya-article-index'
  //       }],
  //       auth: function () {
  //         return secondAuth(this.subNav)
  //       }
  //     }],
  //   auth: function () {
  //     return firstAuth(this.subNav)
  //   }
  // }, 
  // {
  //   id: '8',
  //   name: '知涯升学',
  //   depth: 3,
  //   subNav: [
  //     {
  //       id: '8-1',
  //       name: 'banner管理',
  //       subNav: [{
  //         id: '8-1-1',
  //         name: '首页',
  //         url: 'shengxue/banner-list',
  //         type: 'index',
  //         auth: 'shengxue-banner-index'
  //       }],
  //       auth: function () {
  //         return secondAuth(this.subNav)
  //       }
  //     }
  //   ],
  //   auth: function () {
  //     return firstAuth(this.subNav)
  //   }
  // },
  {
    id: '3',
    name: '知涯卡管理',
    depth: 2,
    subNav: [{
      id: '3-1',
      name: '开卡管理',
      url: 'volunteer/card',
      auth: function () {
        return 'volunteer-card'
      }
    }, {
      id: '3-2',
      name: '线下卡管理',
      url: 'volunteer/use',
      auth: function () {
        return 'volunteer-use'
      }
    }, {
      id: '3-3',
      name: '统计报表',
      url: 'volunteer/report',
      auth: function () {
        return 'card-report'
      }
    }, {
      id: '3-4',
      name: '手动激活',
      url: 'volunteer/manualActivation',
      auth: function () {
        return 'card-user-activation'
      }
    }],
    auth: function () {
      return firstAuth2(this.subNav)
    }
  }, {
    id: '4',
    name: '会员管理',
    depth: 2,
    subNav: [{
      id: '4-1',
      name: '反馈',
      url: 'feedback/list',
      auth: function () {
        return 'feedback-list'
      }
    }, {
      id: '4-2',
      name: '顾问预约',
      url: 'counselorSubscribe/index',
      auth: function () {
        return 'specialist-appoint'
      }
    }, {
      id: '4-3',
      name: '加盟申请',
      url: 'toApplyFor/index',
      auth: function () {
        return 'league-info'
      }
    }, {
      id: '4-4',
      name: '会员管理',
      url: 'memberManagement/index',
      auth: function () {
        return 'user-manager'
      }
    }],
    auth: function () {
      return firstAuth2(this.subNav)
    }
  }, {
    id: '5',
    name: '交易管理',
    depth: 2,
    subNav: [{
      id: '5-1',
      name: '订单',
      url: 'order/list',
      auth: function () {
        return 'order'
      }
    },
    {
      id: '5-2',
      name: '小程序订单',
      url: 'order/mp-list',
      auth: function () {
        return 'order'
      }
    }],
    auth: function () {
      return firstAuth2(this.subNav)
    }
  }, {
    id: '7',
    name: '经销商系统',
    depth: 3,
    subNav: [{
      id: '7-1',
      name: '经销商管理',
      subNav: [{
        id: '7-1-1',
        name: '经销商列表',
        url: 'dealer/list',
        auth: 'dealer-query'
      }],
      auth: function () {
        return secondAuth(this.subNav)
      }
    }
      // {
      //   id: '7-2',
      //   name: '经销商卡管理',
      //   subNav: [{
      //     id: '7-2-1',
      //     name: '绑卡管理',
      //     url: 'card/list',
      //     auth: 'dealer-card-bind'
      //   }, {
      //     id: '7-2-2',
      //     name: '使用管理',
      //     url: 'card/use',
      //     auth: 'dealer-card-use'
      //   }],
      //   auth: function () {
      //     return secondAuth(this.subNav)
      //   }
      // }, {
      //   id: '7-3',
      //   name: '统计报表',
      //   subNav: [{
      //     id: '7-3-1',
      //     name: '统计报表',
      //     url: 'statistics/report',
      //     auth: 'dealer-card-report'
      //   }],
      //   auth: function () {
      //     return secondAuth(this.subNav)
      //   }
      // }
    ],
    auth: function () {
      return firstAuth(this.subNav)
    }
  }, {
    id: '6',
    name: '系统管理',
    depth: 2,
    subNav: [{
      id: '6-1',
      name: '权限管理',
      url: 'system/authority',
      auth: function () {
        return 'system-authority'
      }
    }, {
      id: '6-2',
      name: '用户管理',
      url: 'system/user-list',
      auth: function () {
        return 'system-user'
      }
    }, {
      id: '6-3',
      name: '超级用户',
      url: 'system/super-user',
      auth: function () {
        return 'system-super-user'
      }
    }, {
      id: '6-4',
      name: 'APP自动升级',
      url: 'system/app-list',
      auth: function () {
        return 'system-appUpdate'
      }
    }, {
      id: '6-5',
      name: '组织管理',
      url: 'system/organize-list',
      auth: function () {
        return 'market-org-query'
      }
    }, {
      id: '6-6',
      name: '系统日志',
      url: 'system/systemLog',
      auth: function () {
        return 'log-app'
      }
    }, {
      id: '6-7',
      name: 'OMS日志',
      url: 'system/omsLog',
      auth: function () {
        return 'log-oms'
      }
    }],
    auth: function () {
      return firstAuth2(this.subNav)
    }
  },
  {
    id: '8',
    name: '分账管理',
    depth: 2,
    subNav: [
      {
        id: '8-1',
        name: '明细',
        url: 'sub-account/statistic',
        auth: function () {
          return "finance-record"
        }
      }
    ],
    auth: function () {
      return firstAuth2(this.subNav)
    }
  },
  {
    id: '9',
    name: '线下活动管理',
    depth: 3,
    url: 'activity/list',
    auth: function () {
      return "h5-activity-manager"
    }
  },
  {
    id: '10',
    name: '活动日项目',
    depth: 3,
    url: 'activity/day/list',
    auth: function () {
      return "h5-activity-manager"
    }
  }, {
    id: '11',
    name: '志愿机构版',
    depth: 2,
    subNav: [{
      id: '11-1',
      name: '企业管理',
      url: 'agency/list',
      auth: function () {
        return 'h5-activity-manager'
      }
    }, {
      id: '11-2',
      name: '充值管理',
      url: 'agency/recharge',
      auth: function () {
        return 'h5-activity-manager'
      }
    }],
    auth: function () {
      return firstAuth2(this.subNav)
    }
  }
  ];
  return data
}

/**
 * 如果没有第三级的权限，则第二级不显示
 * @param subNav '第二级菜单'
 */
function secondAuth(subNav) {
  // console.log(subNav)
  let authority = Cookies.getJSON('user').authority
  // TODO:let authority = store.state.authority
  let result = false
  for (let i = 0; i < subNav.length; i++) {
    if (subNav[i].auth !== undefined) {
      // store.state.authority.map(authItem => {
      authority.map(authItem => {
        if (subNav[i].auth === authItem) {
          result = true
        }
      })
    }
  }
  return result
}

/**
 * 如果没有第二级的权限，则第一级不显示
 * @param list '第二级菜单'
 */
function firstAuth(list) {
  let result = false
  for (let i = 0; i < list.length; i++) {
    if (list[i].auth()) {
      result = true
    }
  }
  return result
}

/**
 * 只有两级的情况下，第一级权限显示问题
 * @param  subNav 第二级菜单
 */
function firstAuth2(subNav) {
  let result = false
  let authority = Cookies.getJSON('user').authority
  // TODO:let authority = store.state.authority
  // store.commit('SET_AUTHORITY', authority)
  for (let i = 0; i < subNav.length; i++) {
    // store.state.authority.map(authItem => {
    authority.map(authItem => {
      if (subNav[i].auth() === authItem) {
        result = true
      }
    })
  }
  return result
}

export default getNavJson



// WEBPACK FOOTER //
// ./src/utils/navData.js